import type {BasePanel} from '@Components/panel/panel.types';
import type {AiSubtitleItemResult} from '@Panels/ai-subtitle-panel/components/ai-subtitle-generating/ai-subtitle-generating.types';
import type {AiTranscriptForItemWithParams} from '@Hooks/poster-editor/useAiTranscriptGeneration';
import type {AiTranscriptSupportedLanguage} from '@PosterWhiteboard/items/transcript-item/transcript-item.types';

export const AI_SUBTITLE_PANEL_ID = 'ai-subtitle-panel';

export interface AiSubtitlesPanelProps extends BasePanel {
  hideHeader?: boolean;
  className?: string;
  onClose?(): void;
  onDone?(): void;
  contentClasses?: string;
  doSetItemsOnMount?: boolean;
  showBackButton?: boolean;
  isMobile?: boolean;
  isOpenedInContextualMenu?: boolean;
}

export interface SelectableItemWithAudio {
  duration: number;
  name: string;
  imageUrl: string;
  id: string;
  isSelected: boolean;
  type: 'audio' | 'video';
  sourceProperties: AiTranscriptForItemWithParams;
}

export interface AiSubtitlePanelReduxState {
  items: Record<string, SelectableItemWithAudio>;
  results: Record<string, AiSubtitleItemResult>;
  areUploadsBeingProcessed: boolean;
  inputLanguage: AiTranscriptSupportedLanguage;
  hasLanguageSelectorJustClosed: boolean;
}

export interface AiSubtitlesPanelReduxState {
  aiSubtitlesPanel: AiSubtitlePanelReduxState;
  generationsBatch: AiSubtitlesGenerationBatch;
}

export interface AddAiSubtitlesGenerationResultReduxProps {
  id: string;
  result: AiSubtitleItemResult;
}

export interface AiSubtitlesGenerationBatch {
  currentNumberOfCompletedGenerations: number;
  totalItemsToGenerateSubtitlesFor: number;
}
